<template>
    <rkm-form
        ref="Form"
        show-legend
    >
        <rkm-area
            title="Unidade Solicitante"
            type="fieldset"
        >

            <rkm-row>
                <rkm-col cols="6">
                    <rkm-form-select
                        :options="data.form.unidades"
                        :validations="validations.unidade"
                        label="Unidade"
                        show-default-option
                        text-field="nomeFantasia"
                        v-model="model.unidadeId"
                        :disabled="model.unidadeDisabled ? true : false"
                        value-field="id"
                    />
                </rkm-col>

                <rkm-col cols="6">
                    <rkm-form-select
                        label="Local de atendimento"
                        :options="infraestruturas"
                        :validations="validations.infraestrutura"
                        textField="nome"
                        v-model="model.infraestruturaId"
                        :disabled="model.unidadeDisabled ? true : false"
                        valueField="id"
                        show-default-option
                    />
                </rkm-col>
            </rkm-row>
        </rkm-area>

        <rkm-row>

            <rkm-col
                cols="12"
                v-if="!hideUnidadeSolicitante"
            >

                <FormUnidadeSolicitante
                    ref="FormColeta"
                    :data="data"
                    :cotaUnidadeSolicitante="cotaUnidadeSolicitante"
                    :unidadeId="model.unidadeId"
                    :infraestruturaId="model.infraestruturaId"
                    :unidadeDisabled="model.unidadeDisabled"
                    :newIndex="newIndex"
                    @save="save"
                />
            </rkm-col>
        </rkm-row>
    </rkm-form>
</template>

<script>

// Mixins.
import { object, data } from '@/mixins'

// Components.
import FormUnidadeSolicitante from './components/Form'

// Enums.
import tipoUnidade from '@/enums/exame-laboratorial/tipoUnidade'

export default {
    components: { FormUnidadeSolicitante },
    computed: {
        validations() {

            return {
                unidade: { required: true },
                infraestrutura: { required: true },
            }
        },
        hasIndex() {

            return this.index !== null
        },
        infraestruturas() {

            if (this.model.unidadeId) {

                let infraestruturaPrincipal = this.data.form.unidades.find(u => u.id === this.model.unidadeId).infraestruturas

                if (!this.model.unidadeDisabled) {

                    this.getPrincipal(infraestruturaPrincipal)
                }

                return infraestruturaPrincipal
            }

            return []
        },
    },
    created() {

        this.load()
    },
    data: () => ({
        form: {
            unidades: {},
        },
        model: {
            unidadeId: null,
            unidadeDisabled: false,
            infraestruturaId: null,
            cotaUnidadeSolicitante: false,
        },
        enums: {
            tipoUnidade
        },
        cotaUnidadeSolicitante: [],
        checkCotaLaboratorio: false,
        hideUnidadeSolicitante: false,
        newIndex: null,
    }),
    methods: {
        load() {

            if (this.hasIndex) {

                const objId = this.data.model.cotasUnidadeSolicitante.findIndex((obj => obj.unidadeId == this.item.unidadeId
                    && obj.infraestruturaId == this.item.infraestruturaId));

                this.newIndex = objId

                const data = this.data.model.cotasUnidadeSolicitante[objId]

                this.model.unidadeId = data.unidadeId
                this.model.infraestruturaId = data.infraestruturaId
                this.model.unidadeDisabled = true
                this.cotaUnidadeSolicitante = data.cotaUnidadeSolicitante
            }
        },
        save() {

            this.$refs.Form.validate()
                .then(valid => {

                    if (!valid) return

                        const index = this.data.model.cotasUnidadeSolicitante.findIndex(unidade =>
                            unidade.infraestruturaId === this.model.infraestruturaId)

                        const unidade = this.data.form.unidades.find(u => u.id === this.model.unidadeId)
                        const infraestrutura = this.infraestruturas.find(u => u.id === this.model.infraestruturaId)

                        const param = {
                            unidadeId: unidade.id,
                            unidadeTipoId: this.enums.tipoUnidade.UNIDADE_SOLICITANTE,
                            nomeFantasia: unidade.nomeFantasia,
                            infraestruturaId: infraestrutura.id,
                            infraestruturaNome: infraestrutura.nome,
                            cotaUnidadeSolicitante: this.cotaUnidadeSolicitante,
                        }

                        if (index >= 0) {

                            this.$set(this.data.model.cotasUnidadeSolicitante, index, this.clone(param))
                        } else {

                            this.data.model.cotasUnidadeSolicitante.push(this.clone(param))

                            this.newIndex = this.data.model.cotasUnidadeSolicitante.findIndex((user) =>
                                user.infraestruturaId == infraestrutura.id)
                        }

                        this.$emit('save', this.clone(param))
                })
        },
        handleHideUnidadeSolicitante(value) {
            this.hideUnidadeSolicitante = value
        },
        getPrincipal(infraestruturaPrincipal) {
            this.model.infraestruturaId = infraestruturaPrincipal.find(u => u.principal === true).id
        },
    },
    mixins: [object, data],
    props: {
        data: { type: Object, required: true },
        index: { type: Number, default: null },
        item: { type: Object, default: null },
    },
}
</script>